import React from 'react';

type Callback = (value: any) => void | undefined;

export const keypressCallback = (
  callback: Callback,
  attribute: string,
): ((e: React.KeyboardEvent) => void | undefined) => (e: React.KeyboardEvent) => {
  e.stopPropagation();
  e.preventDefault();
  if (e.key === ' ' || e.key === 'Enter') {
    const option = e.currentTarget.getAttribute(attribute);
    callback(option!);
  }
};
